<!--
 Copyright 2022 by domX Private Company

 All rights reserved,
 also regarding any disposal, exploitation, reproduction,
 editing, distribution, as well as in the event of
 applications for industrial property rights.

 This software contains proprietary and confidential
 information of domX Private Company.
 The disclosure of confidential information without
 express authorization is prohibited.

 This software may include Open Source Software.
 As far as Open Source Software is included,
 your rights for the respective Open Source Software
 components are governed by the applicable
 Open Source Software licenses.
-->

<template class="fill-height">
    <v-card flat class="secondary fill-height pa-12" height="25%">
      <v-form ref="form" lazy-validation>
        <v-subheader class="display-1 grayBold--text">
          {{ $t("selectAddress") }}
        </v-subheader>
        <v-subheader class="subtitle-2 grayBold--text">
          {{ $t("addInstallationAddressSubtitle") }}
        </v-subheader>
        <v-list class="secondary card-content" max-height="80vh" max-width="1000px">
          <v-list-item>
            <v-list-item-content class="grayBold--text">
              <v-list-item-title class="subtitle-2 grayBold--text">
              </v-list-item-title>
              <v-flex xs12 sm12 md12>
                <div style="height: 200px; width: 500px;">
                  <l-map :center="center" :zoom="zoom">
                    <l-tile-layer :url="url"></l-tile-layer>
                    <l-marker :lat-lng="markerCoords" :draggable="true" @dragend="getCoordinates"></l-marker>
                  </l-map>
                </div>
              </v-flex>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-container>
          <v-layout row wrap>
            <v-flex xs12 sm4 md4>
              <v-text-field
              class="ml-5 mr-5 mt-3"
              light
              v-model="lat"
              :label="$t('latitude')"
              dense
              @input="updateCoordinates"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm4 md4>
              <v-text-field
              class="ml-5 mt-3"
              light
              v-model="long"
              :label="$t('longitude')"
              dense
              @input="updateCoordinates"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
        <v-card-actions>
          <v-spacer />
          <v-btn depressed right light color="grayBold--text secondary" @click="hideModal()">
            {{ $t("cancel") }}
          </v-btn>
          <v-btn color="primary" depressed right large class="modal-update" @click="selectCoordinates"><v-icon
              left>mdi-pencil</v-icon>{{ $t("save") }}</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </template>
    
    <script lang="ts">
    import { Component, Vue, Prop } from 'vue-property-decorator';
    import { commonModule, installationsModule } from '@/store/modules/store-accessor';
    import { LMap, LTileLayer, LMarker } from 'vue2-leaflet';
    import { Icon } from "leaflet";
  
    Icon.Default.mergeOptions({
      iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
      iconUrl: require('leaflet/dist/images/marker-icon.png'),
      shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
    });
  
  @Component({
    components: {
      LMap, LTileLayer, LMarker
    }
  })
    export default class AddInstallationAddressModal extends Vue {
  
      @Prop()
      payload!: any;
     
      zoom = 16;
      url = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
      // Default coordinatates: Athens, Greece
      center = [37.983810, 23.727539];
      markerCoords = [37.983810, 23.727539];
      lat = this.markerCoords[0];
      long = this.markerCoords[1];
  
      async hideModal () {
        commonModule.hideSecondModal();
      }
  
      async mounted() {
        commonModule.initSnackbar({});
        this.center = this.payload.coordinates.latitude && this.payload.coordinates.longitude ? [this.payload.coordinates.latitude, this.payload.coordinates.longitude] : [this.markerCoords[0], this.markerCoords[1]];
        this.markerCoords = this.payload.coordinates.latitude && this.payload.coordinates.longitude ? [this.payload.coordinates.latitude, this.payload.coordinates.longitude] : [this.markerCoords[0], this.markerCoords[1]];
        this.lat = this.markerCoords[0];
        this.long = this.markerCoords[1];
      }
  
      updateCoordinates() {
        if(parseFloat((this.lat as any)) &&  parseFloat((this.long as any))) {
          this.markerCoords = [parseFloat((this.lat as any)), parseFloat((this.long as any))];
          this.center = [parseFloat((this.lat as any)), parseFloat((this.long as any))];
        }
      }
  
      async selectCoordinates () {
        if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
            installationsModule.setNewInstallationCoordinates(this.markerCoords);
          this.hideModal();
      }
    }
  
      getCoordinates(event: Record<string, any>) {
        this.markerCoords = [event.target._latlng.lat, event.target._latlng.lng];
        this.lat = event.target._latlng.lat;
        this.long = event.target._latlng.lng;
      }
  
    };
    </script>
  
  <style lang="scss" scoped>
  .card-content {
    overflow: auto;
  }
  </style>